import { PieDonutsDistActivities } from "../../components/Chart"
import { DatePicker } from "../../components/DatePicker"
import { SelectInput } from "../../components/Form"
import HeaderBack from "../../components/HeaderBack"
import CardHeader from "../../components/CardHeader"
import { LoadingWithLabel } from "../../components/Loading"
import { ProgressBar } from "../../components/ProgressBar"
import { Section } from "../../components/Section"
import { TimeLineList } from "../../components/TimeLineList"
import "./styles.scss"

const ActivityDistributionBar = ({
  type,
  complete = 0,
  total = 0,
  currentValue,
  className,
  backgroundColor
}) => (
  <div className={`activity-distribution-bars ${className}-bars`}>
    <div className="activity-distribution-bars-header">
      <span className="bars-type">{type}</span>
      <div className="bars-counter">
        <span className="counter-complete">{complete}</span>
        <span className="counter-total">/{total}</span>
      </div>
    </div>
    <div className="activity-distribution-bars-progress">
      <ProgressBar
        currentValue={complete}
        maxValue={total}
        className={`${className}-bar`}
        backgroundColor={backgroundColor}
      />
    </div>
  </div>
)

const ActivityHistoryScreen = ({
  data,
  distributionActivityData,
  technicianOptions,
  periodOptions,
  handlePeriodSelect,
  handleTechnicianSelect,
  handleFilterActivities,
  selectTechnician,
  handleChangeDate,
  filterDate,
  handleGoBack,
  producer,
  selectPeriod,
  isLoading,
  isDistributionActivityLoading,
  isUserAdmin
}) => {
  
  return (
    <div className="activity-history-container">
      <Section className="activity-history__content">
        <HeaderBack
          title={`Atividades ${!producer ? "" : `| ${producer}`}`}
          handleGoBack={handleGoBack}
        />
        <header className="period-header">
          <h3 className="period-header-title">Período</h3>
          <div className="period-header-inputs">
            <SelectInput
              className="period-select"
              options={periodOptions}
              defaultValue={periodOptions[0]}
              value={selectPeriod}
              handleChange={handlePeriodSelect}
            />
            <div className="period-dates">
              <DatePicker
                placeholder="dd/mm/aaaa"
                className="date1"
                value={filterDate?.startDate || ""}
                defaultValue={filterDate?.startDate || ""}
                onChange={(e) => handleChangeDate("startDate", e)}
              />
              <DatePicker
                placeholder="dd/mm/aaaa"
                className="date1"
                disabled={filterDate?.startDate === ""}
                defaultValue={filterDate?.endDate || ""}
                value={
                  filterDate?.startDate === "" || filterDate?.endDate === ""
                    ? ""
                    : filterDate?.endDate
                }
                onChange={(e) => handleChangeDate("endDate", e)}
              />
            </div>
          </div>
        </header>
        <div className="activity-history-timeline-container">
          <div className="activity-history-timeline__content">
            <TimeLineList data={data} loading={isLoading} />
          </div>
        </div>
      </Section>
      <Section className="activity-history-distribution-container">
        <CardHeader title="Distribuição de atividades" />
        {isUserAdmin &&  
        <div className="technician-select">
          <span className="technician-select-label">Técnico</span>
          <SelectInput
            options={technicianOptions}
            defaultValue={technicianOptions[0]}
            value={selectTechnician}
            handleChange={handleTechnicianSelect}
            isSearchable={true}
            breakLine={false}
          />
        </div>
        }
        <div className="activity-distribution__content">
          {isDistributionActivityLoading ? (
            <><LoadingWithLabel sizeSpinner={32} colorSpinner="primary" labelLoading="Buscando dados..."/></>
          ) : (
            <>
              <div className="activity-distribution__chart">
                <PieDonutsDistActivities data={distributionActivityData} handleClick={handleFilterActivities}/>
              </div>
              <div className="activity-distribution-bars-container">
                <ActivityDistributionBar
                  type="Atendimentos"
                  complete={distributionActivityData?.assistance?.completed}
                  total={distributionActivityData?.assistance?.total}
                  currentValue={80}
                  className="assistance"
                  backgroundColor="#00A800"
                />
                <ActivityDistributionBar
                  type="Plano de Ação"
                  complete={distributionActivityData?.actionPlan?.completed}
                  total={distributionActivityData?.actionPlan?.total}
                  currentValue={50}
                  className="action-plan"
                  backgroundColor="#FFC103"
                />
                <ActivityDistributionBar
                  type="Indicadores"
                  complete={distributionActivityData?.indicators?.completed}
                  total={distributionActivityData?.indicators?.total}
                  currentValue={30}
                  className="indicator"
                  backgroundColor="#FFC103"
                />
              </div>
            </>
          )}
        </div>
      </Section>
    </div>
  )
}

export default ActivityHistoryScreen
